import React from 'react';

export const CourseList = ({ courses = [] }) => {
  return (
    <div>
      <table className="min-w-full text-sm text-left">
        <thead className="bg-gray-100 text-gray-700">
          <tr>
            <th className="px-4 py-2">#</th>
            <th className="px-4 py-2">Course Name</th>
          </tr>
        </thead>
        <tbody>
          {courses.length === 0 ? (
            <tr>
              <td colSpan="2" className="text-center py-10 text-gray-400">
                No courses created
              </td>
            </tr>
          ) : (
            courses.map((c, i) => (
              <tr key={i} className="border-t">
                <td className="px-4 py-2">{i + 1}</td>
                <td className="px-4 py-2 font-medium">{c}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};
